import { IFeature, IPriceV2Types } from '../services';

export const LIGHT_COLOR_THRESHOLD = 128;

export const getColorBrightness = (colorHex: string): number => {
    // for some reason some color are not going from api I guess, investigate why
    // in mean time this extra conditions prevents site from crash and return dark color
    if (!colorHex) {
        return 1;
    }

    const matchedColors = colorHex.substr(1).match(/(\S{2})/g);
    const red = parseInt(matchedColors[0], 16);
    const green = parseInt(matchedColors[1], 16);
    const blue = parseInt(matchedColors[2], 16);

    return (red * 299 + green * 587 + blue * 114) / 1000;
};

export const isColorBright = (colorHex: string): boolean => getColorBrightness(colorHex) > LIGHT_COLOR_THRESHOLD;

export const sortByPrice = (colors: IFeature[]) =>
    colors.sort((interiorA, interiorB) => {
        const priceA = interiorA.pricesV2.find((price) => price.type === IPriceV2Types.B2C_CASH)?.finalPriceInclTax;
        const priceB = interiorB.pricesV2.find((price) => price.type === IPriceV2Types.B2C_CASH)?.finalPriceInclTax;

        if (priceA < priceB) return -1;
        if (priceA > priceB) return 1;
        return 0;
    });
